<template>
  <div class="main jc-center" ref="main">
    <div class="content">
      <div style="width: 58%">
        <div class="title ellipsis">{{ info.title }}</div>
        <div class="info ellipsis">
          {{ info.content }}
        </div>
        <a class="btn">查看详情 »</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: { info: Object },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    info: {
      handler(val) {
        if (val.picture) {
          this.$refs.main.style.background = `url(${val.picture}) no-repeat`;
        }
        this.list = val.wxSchoolPageItemList;
      },
      deep: true,
    },
  },
  mounted() {
    if (this.info.picture) {
      this.$refs.main.style.background = `url(${this.info.picture}) no-repeat`;
    }
    this.list = this.info.wxSchoolPageItemList;
  },
};
</script>
<style scoped>
.main {
  object-fit: cover;
  height: 410px;
  background-size: 100%;
}
.content {
  width: 1200px;
  padding: 80px 12px;
  box-sizing: border-box;
}
.title {
  height: 64px;
  font-size: 48px;
  font-weight: 600;
  color: #096dd9;
}
.info {
  height: 64px;
  margin: 40px 0;
  font-size: 16px;
  color: #595959;
  -webkit-line-clamp: 3;
}
.btn {
  padding: 10px 40px;
  color: #fff;
  background-color: #096dd9;
  border-radius: 4px;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/propaganda/propaganda1/index.vue